import { Dom } from "../common/dom";
import { PageNavigator } from "./page-navigator";
import { NavigationItem } from "./navbar";
import { NavigationUrlHelper } from "./navigation-url-helper";
import { NavigationHelper } from "./navigation-helper";

export class MenuBuilder
{
    static createMenuElement(data: NavigationItem, menuParent: HTMLElement, percentage: number)
    {
        const menuSmallParent = Dom.add("li", menuParent);
        MenuBuilder.createLink(menuSmallParent, data.DisplayName, data.Pages[0], data.Name);

        if (data.Pages.length > 1)
        {
            const submenu = Dom.add("ul", menuSmallParent, "w-dropdown-menu", "w-sub-menu");
            submenu.style.top = `${percentage}%`;
            for (const page of data.Pages)
            {
                const linkSupport = Dom.add("li", submenu);
                MenuBuilder.createLink(linkSupport, PageNavigator.getDisplayName(page), page, data.Name);
            }
        }
    }

    private static createLink(parent: HTMLElement, displayName: string, page: string, parentName: string)
    {
        const link = Dom.add("a", parent);
        link.textContent = displayName;
        link.setAttribute("href",
            `#${NavigationUrlHelper.getPageHash(PageNavigator.getPageInfo(page, parentName))}`);
        link.addEventListener("click", (event) =>
        {
            event.preventDefault();
            PageNavigator.navigateToPage(page, parentName);
            NavigationHelper.dismiss();
        });
    }
}
